import React from "react";
import {
  Paper,
  Typography,
  Autocomplete,
  Chip,
  TextField,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const OptionsStep = ({
  userOptions,
  selectedUsers,
  setSelectedUsers,
  deleteExisting,
  setDeleteExisting,
}) => {
  return (
    <>
      <Paper
        elevation={0}
        sx={{ p: 2.5, mb: 3, borderRadius: 2, border: "1px solid #eaeaea" }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "1.2rem", sm: "1.3rem" },
            mb: 1,
          }}
        >
          Select Users to Import to...
        </Typography>

        <Autocomplete
          disablePortal
          multiple
          disableCloseOnSelect
          options={userOptions}
          value={selectedUsers}
          onChange={(_, values) => setSelectedUsers(values)}
          getOptionLabel={(option) =>
            option?.email ||
            `${option?.firstName || ""} ${option?.lastName || ""}`.trim()
          }
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                fontSize: { xs: "1.2rem", sm: "1.3rem" },
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              {option?.email ||
                `${option?.firstName || ""} ${option?.lastName || ""}`.trim()}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select users"
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontSize: { xs: "1.2rem", sm: "1.3rem" },
                },
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "1.2rem", sm: "1.3rem" },
                },
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option?.id || index}
                    label={
                      option?.email ||
                      `${option?.firstName || ""} ${
                        option?.lastName || ""
                      }`.trim()
                    }
                    size="medium"
                  />
                ))
              }
            />
          )}
        />
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: 2,
          border: "1px solid #fde68a",
          backgroundColor: "#fff7ed",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={deleteExisting}
                onChange={(e) => setDeleteExisting(e.target.checked)}
                size="large"
              />
            }
            label={
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "1.2rem", sm: "1.3rem" },
                  }}
                >
                  Delete Existing Customers
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: { xs: "1rem", sm: "1.1rem" },
                  }}
                >
                  Remove all existing customer data before importing
                </Typography>
              </Box>
            }
          />
        </Box>
      </Paper>
    </>
  );
};

export default OptionsStep;
